import { statusIntent, type IntentName } from "@/design";

import type { AttentionReason } from "../api/use-orders";

import type { Order } from "./types";

// Severity order for picking ONE icon when an order carries multiple
// exception reasons: an inventory problem outranks a still-pending buyer
// request (see spec 2026-09-22-mo3-seller-cancel-exceptions).
const SEVERITY: AttentionReason[] = ["oversold", "buyer_cancel_requested"];

export function topReviewReason(reasons: Order["reviewReasons"]): AttentionReason | null {
  if (!reasons || reasons.length === 0) return null;
  return SEVERITY.find((r) => reasons.includes(r)) ?? null;
}

/** danger/warning color for the highest-severity flag, or null when unflagged (per statusIntent's "review_reason" domain — never a hand-rolled color). */
export function reviewFlagIntent(reasons: Order["reviewReasons"]): IntentName | null {
  const top = topReviewReason(reasons);
  return top ? statusIntent("review_reason", top) : null;
}
